import * as ActionType from '../constants/constant_action_types';

export function openItemUomModal() {
  return { type: ActionType.OPEN_ITEM_UOM_MODAL };
}

export function closeItemUomModal() {
  return { type: ActionType.CLOSE_ITEM_UOM_MODAL };
}

export function setItemUom(data) {
  return { type: ActionType.SET_ITEM_UOM, data };
}

export function clearItemUom() {
  return { type: ActionType.CLEAR_ITEM_UOM };
}

export function viewItemUom() {
  return { type: ActionType.VIEW_ITEM_UOM_MODAL };
}

export function editItemUom() {
  return { type: ActionType.EDIT_ITEM_UOM_MODAL };
}

export function saveItemUom(data) {
  return { type: ActionType.SAVE_ITEM_UOM, data };
}

export function deleteItemUom(data) {
  return { type: ActionType.DELETE_ITEM_UOM, data };
}

export function getItemUoms(filters) {
  return { type: ActionType.GET_ITEM_UOMS, filters };
}

export function getItemUom(id) {
  return { type: ActionType.GET_ITEM_UOM, id };
}

export function setItemUomPagination(page, perPage, totalRows) {
  return {
    type: ActionType.SET_ITEM_UOMS_PAGINATION,
    page,
    perPage,
    totalRows,
  };
}
